"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.helpLink = exports.defaultDAManifestFileName = exports.defaultOpenApiOutputDir = void 0;
exports.defaultOpenApiOutputDir = "specs"; // The default openapi files will be generated in appPackage/.generated/specs
exports.defaultDAManifestFileName = "declarativeAgent.json"; // The default declarative agent manifest file name
exports.helpLink = "https://aka.ms/teamsfx-actions/typeSpec-compile";
//# sourceMappingURL=constants.js.map